export default {

    data(){
        return {
        }
    },
    computed:{
    },
    methods: {
        loadChartV2(chartName, data, options){
            console.log(chartName, data, options);
            this.charts[chartName].datasets = [];
            for ( key in data ) {
                //  find dataset by label
                let datasetIndex = this.charts[chartName].datasets.findIndex(dataset => dataset.label === key);
                if(datasetIndex){
                    this.charts[chartName].datasets[datasetIndex] = data[key];
                }
            }
            this.charts[chartName].labels = this.getLabelsFromDatasets(chartName);
            this.charts[chartName].loading = false; 
        },

        getLabelsFromDatasets(chartName){
            let labels = [];
            this.charts[chartName].datasets.forEach(function(dataset){
                labels.push(dataset.label);
            });
            return labels;
        }
    }
}